import { graphql } from 'gatsby';
import React from 'react';

import {
  Drupal_FieldParagraphNineteenHeroFieldNineteenCtas,
  Drupal_ParagraphNineteenHero
} from '../../../generated/graphql';
import NineteenCta from '../nineteen-cta/nineteen-cta';
import { Heading } from 'lucid-components-react';
import './nineteen-hero.scss';

interface Props {
  entity: Drupal_ParagraphNineteenHero;
}

const NineteenHero = ({
  entity: { fieldHeader, fieldSubheader, fieldNineteenCtas }
}: Props) => (
  <header className="nineteen-hero">
    <div className="lucid-container">
      <Heading
        color="white"
        css={{
          maxWidth: '45rem'
        }}
      >
        {fieldHeader}
      </Heading>
      <p className="nineteen-hero__subheader">{fieldSubheader}</p>
      {(fieldNineteenCtas as Drupal_FieldParagraphNineteenHeroFieldNineteenCtas[]).map(
        ({ entity }, index) => (
          <NineteenCta
            primary={index === 0}
            key={entity!.entityId!}
            entity={entity!}
          />
        )
      )}
    </div>
  </header>
);

export default NineteenHero;

export const query = graphql`
  fragment nineteenHero on Drupal_ParagraphNineteenHero {
    fieldHeader
    fieldSubheader
    fieldNineteenCtas {
      entity {
        ...nineteenCta
      }
    }
  }
`;
